import { Link as RouterLink } from 'react-router-dom';
import { Box, Container, Stack, Typography, alpha } from '@mui/material';

// ==============================|| ブログのヘッダー ||============================== //
//
// 記事には検索から直接着地する人がほとんどで、その人はトップページを見ていない。
// 画面のどこにも sサービス名が出ていないと、
//   - 何のサイトの記事なのか分からない(書き手が信用できるか判断できない)
//   - トップページに戻る手段がフッターまでスクロールするしかない
// という状態になる。1万字を超える記事ではフッターは遠すぎる。
//
// そこで、ブログの2ページ(一覧・記事)にだけ細いヘッダーを置いている。
// LP側はファーストビューの訴求を邪魔したくないためヘッダーを持たない作りなので、
// サイト共通のヘッダーにはせず、ここに閉じている。
//
// ロゴは components/logo の SVG ではなく文字にしている。
// フッターのサービス名表記(OHANA AI のワードマーク)と字面をそろえるため。
//
// ここに資料請求ボタンは置かない。行き先であるトップページのファーストビューに
// 資料請求フォームがあるため、ホームへ送れば同じところに着く。
// 行き先が2つ並ぶと「まずどちらを押すか」が分かれるので、バー全体をホームへの1本にしている。

const primaryColor = '#2aa1af';

const BlogHeader = () => (
    <Box
        component="header"
        sx={{
            borderBottom: `1px solid ${alpha(primaryColor, 0.16)}`,
            bgcolor: alpha('#fff', 0.92),
            // 読みながらでもトップに戻れるよう、スクロールしても上に残す
            position: 'sticky',
            top: 0,
            zIndex: 10,
            backdropFilter: 'blur(8px)'
        }}
    >
        <Container maxWidth="md">
            {/* バーの帯そのものをリンクにしている。狭い画面でも押し外しにくくするため */}
            <Stack
                component={RouterLink}
                to="/"
                direction="row"
                alignItems="baseline"
                spacing={1.25}
                sx={{ textDecoration: 'none', minWidth: 0, py: { xs: 1.25, md: 1.5 } }}
            >
                <Typography
                    component="span"
                    sx={{ color: primaryColor, fontWeight: 900, fontSize: { xs: '1rem', md: '1.1rem' }, letterSpacing: '0.02em', whiteSpace: 'nowrap' }}
                >
                    OHANA AI
                </Typography>
                {/* 狭い画面では説明を落とし、サービス名だけ残す */}
                <Typography
                    component="span"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        color: '#6b7280',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    児発・放デイの書類作成AI
                </Typography>
            </Stack>
        </Container>
    </Box>
);

export default BlogHeader;
